import React from 'react';
import PropTypes from 'prop-types';
import SelectTicketsFormStandard from './select-tickets/select-tickets-standard';
import SelectTicketsFormHospitality from './select-tickets/select-tickets-hospitality';
import {
    PRODUCT_TYPE_HOSPITALITY,
    PRODUCT_TYPE_TICKET,
    PRODUCT_TYPE_PARKING
} from '../../../general/js/basket/constants';
import ProductsHelper from './products-helper';
import SelectTicketsAside from './select-tickets/select-tickets-aside';
import {
    ROUTE_EXTRAS,
    ROUTE_PARKING,
    ROUTE_PARKING_STANDALONE,
    SCENARIO_HOSPITALITY,
    SCENARIO_HOSPITALITY_WITH_EXTRAS,
    SCENARIO_STANDARD_WITH_EXTRAS,
    SCENARIO_STANDARD
} from './constants';

class SelectTicketsPage extends React.Component {
    getNextRoute() {
        let nextRoute = ROUTE_PARKING;

        if (this.props.isParkingStandaloneConfiguration){
            nextRoute = ROUTE_PARKING_STANDALONE;
        }

        if (this.isHospitality() || this.isStandardWithExtras()) {
            nextRoute = ROUTE_EXTRAS;
        }

        return nextRoute;
    }

    isHospitality() {
        return this.props.currentScenario === SCENARIO_HOSPITALITY ||
            this.props.currentScenario === SCENARIO_HOSPITALITY_WITH_EXTRAS;
    }

    isStandardWithExtras() {
        return this.props.currentScenario === SCENARIO_STANDARD_WITH_EXTRAS;
    }

    onClearTicketsSelection() {
        const paramsList = this.props.ticketsList.map((ticket) =>
            Object.assign({}, {
                type: ticket.type,
                tag: ticket.tag
            }));

        this.props.onClearSelection(paramsList);
    }

    isNextStepAvailable() {
        if (this.props.currentScenario == SCENARIO_STANDARD_WITH_EXTRAS)
        {
            if (this.hasSelectedTickets())
                return true;
            return false;
        }

        if(this.props.currentScenario == SCENARIO_STANDARD)
        {
            return this.hasParkingTickets();
        }  

        return this.props.currentScenario !== SCENARIO_HOSPITALITY;
    }

    hasSelectedTickets() {
        return this.props.ticketsList.some((ticket) => ticket.quantity > 0);
    }

    hasParkingTickets(){
        return ProductsHelper.getProductsList(
            this.props.productGroupsList,
            this.props.basket.productGroups,
            (product) => product.type === PRODUCT_TYPE_PARKING
        ).length > 0;

    }

    render() {
        return (
            <React.Fragment>
                <div className="ticket-builder__main">
                    {
                        this.isHospitality() ?

                            <SelectTicketsFormHospitality
                                dictionary={this.props.dictionary}
                                productGroupsList={this.props.productGroupsList}
                                categoriesList={this.props.categoriesList}
                                ticketsList={this.props.ticketsList}
                                isNextStepAvailable={this.isNextStepAvailable()}
                                onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                                onClearSelection={() => this.onClearTicketsSelection()}
                                quantityModifier={this.props.quantityModifier}/> :

                            <SelectTicketsFormStandard
                                dictionary={this.props.dictionary}
                                productGroupsList={this.props.productGroupsList}
                                ticketsList={this.props.ticketsList}
                                isNextStepAvailable={this.isNextStepAvailable()}
                                onApplyProductsQuantity={this.props.onApplyProductsQuantity}
                                onClearSelection={() => this.onClearTicketsSelection()}/>
                    }
                </div>
                <div className="ticket-builder__aside">
                    <SelectTicketsAside
                        basket={this.props.basket}
                        nextRoute={this.getNextRoute()}
                        currentScenario={this.props.currentScenario}
                        productGroupsList={this.props.productGroupsList}
                        onToggleBasketMobile={this.props.onToggleBasketMobile}
                        onStartCheckout={this.props.onStartCheckout}
                        isNextStepAvailable={this.isNextStepAvailable()}
                        isReadyToPay={this.hasSelectedTickets()}
                        basketUrl={this.props.basketUrl}
                    />
                </div>
            </React.Fragment>
        );
    }
}

SelectTicketsPage.propTypes = {
    dictionary: PropTypes.object.isRequired,
    basket: PropTypes.object,
    productGroupsList: PropTypes.array,
    categoriesList: PropTypes.array,
    ticketsList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    onStartCheckout: PropTypes.func.isRequired,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func,
    onToggleBasketMobile: PropTypes.func,
    isParkingStandaloneConfiguration: PropTypes.bool
};

export default function TicketListProvider(props) {
    const ticketsList = ProductsHelper.getProductsList(
        props.productGroupsList,
        props.basket.productGroups,
        (product) => product.type === PRODUCT_TYPE_TICKET || product.type === PRODUCT_TYPE_HOSPITALITY
    );

    return (
        <SelectTicketsPage {...props} ticketsList={ticketsList}/>
    );
}